import React, { Component } from 'react';
import _ from 'lodash';

class NumberFormatSection extends Component {
  constructor(props){
    super(props)

    this.renderRow = this.renderRow.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(index, event){
    let value = event.target.value;
    let { document_templates } = this.props;
    document_templates[index].number_format = value;

    this.props.onUpdateIssueNumberFormat(document_templates);
  }

  renderRow(document_template, index){
    if (document_template.number_format === "'RRRR'") { return }
    return (
      <div key={index} className="mb-2 row">
        <label htmlFor="document_code_internal" className="col-sm-2 col-form-label">
          {document_template.name}
        </label>
        <div className="col-sm-10">
          <input 
            type='text' 
            name={document_template.id} 
            value={document_template.number_format || ''} 
            onChange={this.onChange.bind(this, index)} 
            className='form-control form-control-sm' />
        </div>
      </div>
    )
  }

  render(){
    let document_templates = this.props.document_templates;
    return(
      <div>
        <div className="form-group row">
          <div className='col-12 text-danger'>
            R-แทนหมายเลขเอกสาร,OrgCode-แทนหมายเลขหน่วยงาน,OwnerFrontRef-แทนหมายเลขหน่วยงานที่ออกเลขใบปะหน้า-YYYY-แทนปี 
            ตัวอย่างเช่น 'มท '+'OrgCode'+'/'+'RRRR' หรือ 'ศธ ' + 'OwnerFrontRef' + 'RRRR'
          </div>
        </div>

        {!_.isEmpty(document_templates) && _.map(document_templates, this.renderRow)}
      </div>
    )
  }
}

export default NumberFormatSection;



// WEBPACK FOOTER //
// ./src/components/settings/NumberFormatSection.js